<div id="wrapper">
  <div>
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
  </div>
  <div>
    <app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event"
      (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event"
      (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
      (updateInitializeData)="this.initializeData()">
    </app-tab-nav>
  </div>
  <div style="margin-bottom: 0px;">
    <app-tab-nav></app-tab-nav>
  </div>
  <div class="allcont logsize m-top-i">
    <div class="basicrow ">
      <div class="container">
        <div class="basicr-line-i">
          <div class="fulltitle  f-btitle autodef">
            <span><img width="100%" class="icon-iptv-2" src="/assets/images/icon_IPTV2.png"></span> IPTV
          </div>
        </div>
        <!-- escribir desde aqui -->
        <div class="center-iptv">
          <div class="general-iptv">
            <div class="iptv-box ">
              <div class="iptv-img">
                <img src="/assets/images/reg-a-icon.png">
              </div>
              <div class="btitle">
                Crea tu cuenta IPTV
              </div>
              <div class="iptv-text">
                Ingresa tu correo electrónico. Lo usarás para iniciar sesión en todos tus dispositivos.
              </div>
              <div>
                <div class="iptv-text black-text ">
                  User ID
                </div>
                <form [formGroup]="signupForm">
                  <div class="basicrow row-box">
                    <input class="inp-f payup qt" required formControlName="email" type="text"
                      (keypress)="this.global.validateInputKey($event)" (blur)="this.global.validateInputKey($event)"
                      placeholder="Correo Electrónico" autocomplete="off">
                    <a (click)="validador()" id="btnApply" class="btns payup vcenter cursorP">
                      <span class="tabcell">
                        Validar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                      </span>
                    </a>
                    <!-- <div class="plan-see-btn">
                      <div class="line">
                        <div class="button-white" (click)="validador()">
                          Validar <img class="img-litle" src="/assets/images/r-arrow.png">
                        </div>
                      </div>
                    </div> -->
                    <div [hidden]="signupForm.controls.email.value || signupForm.controls.email.untouched"
                      class="alert alert-danger top-none">
                      Email Requerido
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
